//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ROVEmbed from 'rutube-ok-vkvideo-embed'

export default {
  name: 'YoutubeIframe',
  props: {
    id: {
      type: String,
      require: true,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    videoId: {
      type: String,
      require: true,
      default: '',
    },
  },
  data() {
    return {
      player: {},
      status: 5,
    }
  },
  computed: {
    getVideoId() {
      return this.videoId.split('embed/')[1]
    },
    isYoutube() {
      return ROVEmbed.getPlatform(this.videoId) === undefined
    },
    getPlayerIframeCode() {
      if (this.videoId === '') return ''

      return ROVEmbed({
        url: this.videoId,
        size: {
          width: this.width,
          height: this.height,
        },
      })
    },
  },
}
